import { TwoColumnLayout } from '@factorialco/f0-react'
import { CompetencyFragment, TrainingDetailFragment } from 'generated/resources/graphql'

import MainContent from './MainContent'
import SideContent from './SideContent'

export const Overview = ({
  training,
  competencies,
}: {
  training: TrainingDetailFragment
  competencies: CompetencyFragment[] | []
}) => {
  const sideContent = <SideContent training={training} />
  const mainContent = <MainContent training={training} competencies={competencies} />
  return <TwoColumnLayout sideContent={sideContent}>{mainContent}</TwoColumnLayout>
}
